import { render } from "./CrearRecepcionPage.vue?vue&type=template&id=44434ccf&scoped=true"
import script from "./CrearRecepcionPage.vue?vue&type=script&lang=js"
export * from "./CrearRecepcionPage.vue?vue&type=script&lang=js"

import "./CrearRecepcionPage.vue?vue&type=style&index=0&id=44434ccf&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44434ccf"]])

export default __exports__